import React from 'react';
import { ToastContainer } from 'react-toastify';

import ArtistsBrowse from '../components/ArtistsBrowse';

const ArtistsBrowseApp = (props) => (
  <>
    <ArtistsBrowse {...props} />
    <ToastContainer icon={false} />
  </>
);

export default ArtistsBrowseApp;
